import { Instance } from 'mobx-state-tree';
import { RouteConstraintStartLocationDtoModelBase } from './RouteConstraintStartLocationDtoModel.base';

/* The TypeScript type of an instance of RouteConstraintStartLocationDtoModel */
export interface RouteConstraintStartLocationDtoModelType extends Instance<typeof RouteConstraintStartLocationDtoModel.Type> {}

/* A graphql query fragment builders for RouteConstraintStartLocationDtoModel */
export { selectFromRouteConstraintStartLocationDto, routeConstraintStartLocationDtoModelPrimitives, RouteConstraintStartLocationDtoModelSelector } from './RouteConstraintStartLocationDtoModel.base';

/**
 * RouteConstraintStartLocationDtoModel
 */
export const RouteConstraintStartLocationDtoModel = RouteConstraintStartLocationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
